module.exports = __webpack_public_path__ + "img/logo.ce98d1dc.png";